/**
 * Featured boxes: nudges the icon ::after glow with pointer position (--icon-glow-x/y on .featured-boxes__item).
 * Pure CSS cannot read mouse coordinates; this only runs for fine pointers + hover.
 */
const BLOCK_SEL = '.acf-block--featured-boxes';
const ITEM_SEL = '.featured-boxes__item';
/** Max translate in px each axis (subtle parallax). */
const MAX_OFFSET = 10;

function initFeaturedBoxesIconGlow() {
  if (typeof document === 'undefined') {
    return;
  }
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) {
    return;
  }
  if (!window.matchMedia?.('(hover: hover) and (pointer: fine)')?.matches) {
    return;
  }

  const blocks = document.querySelectorAll(BLOCK_SEL);
  if (!blocks.length) {
    return;
  }

  blocks.forEach((block) => {
    block.querySelectorAll(ITEM_SEL).forEach((item) => {
      let raf = 0;
      let lastX = 0;
      let lastY = 0;

      const onMove = (e) => {
        if (!e.isPrimary) {
          return;
        }
        lastX = e.clientX;
        lastY = e.clientY;
        if (raf) {
          return;
        }
        raf = window.requestAnimationFrame(() => {
          raf = 0;
          const r = item.getBoundingClientRect();
          if (r.width < 1 || r.height < 1) {
            return;
          }
          const nx = ((lastX - r.left) / r.width) * 2 - 1;
          const ny = ((lastY - r.top) / r.height) * 2 - 1;
          const cx = Math.max(-1, Math.min(1, nx));
          const cy = Math.max(-1, Math.min(1, ny));
          item.style.setProperty('--icon-glow-x', `${cx * MAX_OFFSET}px`);
          item.style.setProperty('--icon-glow-y', `${cy * MAX_OFFSET}px`);
        });
      };

      const reset = () => {
        if (raf) {
          window.cancelAnimationFrame(raf);
          raf = 0;
        }
        item.style.setProperty('--icon-glow-x', '0px');
        item.style.setProperty('--icon-glow-y', '0px');
      };

      item.addEventListener('pointermove', onMove);
      item.addEventListener('pointerleave', reset);
      item.addEventListener('pointercancel', reset);
    });
  });
}

function whenReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    window.queueMicrotask(fn);
  }
}

whenReady(initFeaturedBoxesIconGlow);
